import script from "./list-user-role-dynamic.vue?vue&type=script&setup=true&lang=js"
export * from "./list-user-role-dynamic.vue?vue&type=script&setup=true&lang=js"

import "./list-user-role-dynamic.vue?vue&type=style&index=0&id=2809c63c&lang=scss&scoped=true"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2809c63c"]])

export default __exports__